import { cva } from 'class-variance-authority';

export const toggleGroupVariants = cva(
  [
    'inline-flex',
    'flex-row',
    'flex-wrap',
    'items-center',
    'gap-spacing-sys-spacing-4',
    'rounded-radius-comp-button',
  ],
  {
    variants: {
      variant: {
        default: 'bg-color-ref-transparency-lighten-4 p-spacing-sys-spacing-4',
        transparent: 'bg-color-ref-transparency-lighten-0',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
